let ChatRequestMessageType=1

let ChatRequestMessage = function (to,content,contentType){
	this.to=to
	this.content=content
	//0:文本
	this.contentType=contentType
	this.messageType=ChatRequestMessageType
}

export {
	ChatRequestMessage
}